import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';
import { getBillingProductIds, getOfferPositionsData, getOfferTitle } from '@/shared/lib/analytics';

interface OfferAnalyticsParams {
    buttonText: string;
    offer: Offer;
    entityType?: string;
}

interface OfferAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}

export function createOfferAnalytics(
    eventSender: AnalyticsSender,
    { buttonText, entityType, offer }: OfferAnalyticsParams
): OfferAnalytics {
    const { catalogCompositeOffer, analyticData } = offer;
    const { tariffOffer, optionOffers } = catalogCompositeOffer ?? {};

    const commonData = {
        buttonText,
        offerTitle: getOfferTitle(offer),
        offerTariffName: tariffOffer?.tariff?.name ?? '',
        offerOptionNames: optionOffers?.[0]?.option?.name ?? '',
        billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
        billingProductIds: getBillingProductIds({
            tariffOfferName: tariffOffer?.name,
            optionOfferNames: optionOffers?.[0]?.name,
        }),
    };

    const offersPositionsData = getOfferPositionsData({
        offersBatchId: analyticData?.batchId ?? '',
        offersPositionId: analyticData?.positionId ?? '',
    });

    return {
        showed() {
            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                ...commonData,
                show: offersPositionsData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
        navigated() {
            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                ...commonData,
                click: offersPositionsData,
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                ...commonData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
    };
}
